<template>
  <div v-if="$route.name !== 'yachtDelivery'">
    <v-btn
      v-if="$can('set-logistics-plan', 'Yacht')"
      class="text-capitalize"
      color="primary"
      rounded
      text
      block
      :to="{ name: $route.name.includes('service') ? 'serviceYachtDelivery' : 'yachtDelivery', params: { id: yacht.id }}"
    >
      <v-icon
        left
        small
      >
        format_list_numbered
      </v-icon>
      Set Logistics Plan
    </v-btn>
  </div>
</template>

<script>
import Yacht from '@/models/Yacht'

export default {
    name: 'PendingPlan',
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        yachtStatuses: Yacht
      }
    }
  }
</script>
